import { render } from "./SaleQuickPanel.vue?vue&type=template&id=fb15ac52&scoped=true"
import script from "./SaleQuickPanel.vue?vue&type=script&lang=js"
export * from "./SaleQuickPanel.vue?vue&type=script&lang=js"

import "./SaleQuickPanel.vue?vue&type=style&index=0&id=fb15ac52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb15ac52"]])

export default __exports__